/**
 * Central config for SEO and GEO.
 * Use REACT_APP_SITE_URL in production (e.g. https://decklink.co).
 */
export const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://decklink.co';

/** Default locale for geo and hreflang */
export const DEFAULT_LOCALE = 'en-US';

/** Geographic targeting (ISO 3166-1 or region code) */
export const GEO_REGION = 'US';

/** Site name for og:site_name and branding */
export const SITE_NAME = 'DeckLink';

/** Short tagline for meta descriptions */
export const SITE_TAGLINE = 'Impress investors and raise capital with a single, powerful link.';
